import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { jsx as e } from "react/jsx-runtime";
import { useRef as t, useEffect as n, useCallback as r, createContext as i, useContext as o, useState as s } from "react";
import { useSpring as u, animated as l, config as c, useTransition as a } from "react-spring";
import { useDrag as d } from "@use-gesture/react";
import { Subject as m } from "rxjs";
import h from "screenfull";

function f() {
  var e = t(new m());
  return {
    useListenToCustomEvent: function useListenToCustomEvent(t) {
      n(function () {
        var n = e.current.subscribe(t);
        return function () {
          return n.unsubscribe();
        };
      }, [t]);
    },
    emitObservable: function emitObservable(t) {
      e.current.next(t);
    }
  };
}

function g(_ref) {
  var e = _ref.mainCarouselWrapperRef,
      r = _ref.emitObservable,
      i = _ref.handleResize;
  var o = t(!1);

  function s(e) {
    o.current = e;
  }

  return n(function () {
    function e() {
      document.fullscreenElement && (s(!0), r({
        eventName: "onFullscreenChange",
        isFullscreen: !0
      }), i && i()), document.fullscreenElement || (s(!1), r({
        eventName: "onFullscreenChange",
        isFullscreen: !1
      }), i && i());
    }

    if (h.isEnabled) return h.on("change", e), function () {
      h.isEnabled && h.off("change", e);
    };
  }), {
    enterFullscreen: function enterFullscreen(t) {
      h.isEnabled && h.request(t || e.current);
    },
    exitFullscreen: function exitFullscreen() {
      h.isEnabled && h.exit();
    },
    getIsFullscreen: function getIsFullscreen() {
      return o.current;
    }
  };
}

function p(e) {
  var r = t(!1);
  n(function () {
    if (!r.current) {
      var _t = e();

      return r.current = !0, function () {
        _t && _t();
      };
    }
  }, []);
}

function b(_ref2) {
  var n = _ref2.items,
      r = _ref2.withThumbs,
      _ref2$thumbsSlideAxis = _ref2.thumbsSlideAxis,
      i = _ref2$thumbsSlideAxis === void 0 ? "x" : _ref2$thumbsSlideAxis,
      o = _ref2.springConfig,
      s = _ref2.thumbsWrapperRef,
      c = _ref2.prepareThumbsData;

  var a = t(null),
      _u = u(function () {
    var _ref3;

    return _ref3 = {}, _defineProperty(_ref3, i, 0), _defineProperty(_ref3, "config", o), _ref3;
  }),
      _u2 = _slicedToArray(_u, 2),
      d = _u2[0],
      m = _u2[1];

  p(function () {
    if (r) {
      if (n.some(function (e) {
        return !e.renderThumb;
      })) throw new Error("The renderThumb property is missing in one or more items. You need to add the renderThumb property to every item of the carousel when the prop withThumbs={true} or eventually set withThumbs={false}.");
    }
  });
  return {
    thumbsFragment: r ? e(l.div, Object.assign({
      ref: a
    }, "x" === i ? {
      scrollLeft: d.x
    } : {
      scrollTop: d.y
    }, {
      style: _objectSpread({
        display: "flex",
        flex: 1,
        position: "relative",
        flexDirection: "x" === i ? "row" : "column"
      }, "x" === i ? {
        overflowX: "auto"
      } : {
        overflowY: "auto",
        maxHeight: "100%"
      })
    }, {
      children: function () {
        function e(e) {
          return e.map(function (e) {
            return {
              id: e.id,
              renderThumb: e.renderThumb
            };
          });
        }

        return c ? c(e(n)) : e(n);
      }().map(function (_ref4) {
        var t = _ref4.id,
            n = _ref4.renderThumb;
        var r = "thumb-".concat(t);
        return e("div", Object.assign({
          id: r
        }, {
          children: n
        }), r);
      })
    }), void 0) : null,
    handleThumbsScroll: function handleThumbsScroll(e) {
      s && s.current && (a.current = s.current);
      var t = a.current.querySelector("#thumb-".concat(n[e].id));

      if (t) {
        var _r = a.current,
            _o = "x" === i ? "offsetWidth" : "offsetHeight",
            _s = "x" === i ? "scrollLeft" : "scrollTop",
            _u3 = function (_ref5) {
          var e = _ref5.thumbNode,
              t = _ref5.offsetDirection,
              n = _ref5.offsetDimension;
          return e[t] + e[n] / 2;
        }({
          thumbNode: t,
          offsetDimension: _o,
          offsetDirection: "x" === i ? "offsetLeft" : "offsetTop"
        }),
            _l = function (_ref6) {
          var e = _ref6.thumbWrapper,
              t = _ref6.offsetDimension;
          return e[t] / 2;
        }({
          thumbWrapper: _r,
          offsetDimension: _o
        });

        m.start({
          from: _defineProperty({}, i, function (_ref7) {
            var e = _ref7.thumbWrapper,
                t = _ref7.scrollDirection;
            return e[t];
          }({
            thumbWrapper: _r,
            scrollDirection: _s
          })),
          to: _defineProperty({}, i, function (_ref8) {
            var t = _ref8.thumbWrapper,
                r = _ref8.thumbOffsetPosition,
                o = _ref8.thumbScrollDimension,
                s = _ref8.offsetDimension;
            var u = "x" === i ? "scrollWidth" : "scrollHeight";
            return e === n.length - 1 || r - o > t[u] - t[s] ? t[u] - t[s] : 0 === e ? 0 : r - o;
          }({
            thumbWrapper: _r,
            thumbOffsetPosition: _u3,
            thumbScrollDimension: _l,
            offsetDimension: _o
          })),
          onChange: function onChange(e) {
            "x" === i ? a.current.scrollLeft = e.x : a.current.scrollTop = e.y;
          }
        });
      }
    }
  };
}

var v = i(void 0);

function x() {
  var e = o(v);
  if (!e) throw new Error("useSpringCarouselContext isn't being used within the useSringCarousel context; \n    use the context only inside a component that is rendered within the Carousel.");
  return e;
}

function w(_ref9) {
  var i = _ref9.items,
      _ref9$withLoop = _ref9.withLoop,
      o = _ref9$withLoop === void 0 ? !1 : _ref9$withLoop,
      _ref9$draggingSlideTr = _ref9.draggingSlideTreshold,
      s = _ref9$draggingSlideTr === void 0 ? 100 : _ref9$draggingSlideTr,
      _ref9$springConfig = _ref9.springConfig,
      a = _ref9$springConfig === void 0 ? c.default : _ref9$springConfig,
      _ref9$shouldResizeOnW = _ref9.shouldResizeOnWindowResize,
      m = _ref9$shouldResizeOnW === void 0 ? !0 : _ref9$shouldResizeOnW,
      _ref9$withThumbs = _ref9.withThumbs,
      h = _ref9$withThumbs === void 0 ? !1 : _ref9$withThumbs,
      _ref9$enableThumbsWra = _ref9.enableThumbsWrapperScroll,
      x = _ref9$enableThumbsWra === void 0 ? !0 : _ref9$enableThumbsWra,
      _ref9$carouselSlideAx = _ref9.carouselSlideAxis,
      w = _ref9$carouselSlideAx === void 0 ? "x" : _ref9$carouselSlideAx,
      _ref9$thumbsSlideAxis = _ref9.thumbsSlideAxis,
      y = _ref9$thumbsSlideAxis === void 0 ? "x" : _ref9$thumbsSlideAxis,
      T = _ref9.thumbsWrapperRef,
      I = _ref9.prepareThumbsData,
      _ref9$itemsPerSlide = _ref9.itemsPerSlide,
      S = _ref9$itemsPerSlide === void 0 ? 1 : _ref9$itemsPerSlide,
      _ref9$initialActiveIt = _ref9.initialActiveItem,
      C = _ref9$initialActiveIt === void 0 ? 0 : _ref9$initialActiveIt,
      _ref9$initialStarting = _ref9.initialStartingPosition,
      A = _ref9$initialStarting === void 0 ? "start" : _ref9$initialStarting,
      _ref9$disableGestures = _ref9.disableGestures,
      F = _ref9$disableGestures === void 0 ? !1 : _ref9$disableGestures;
  var N = t(!1);
  var E = t("next"),
      O = o ? [].concat(_toConsumableArray(i), _toConsumableArray(i), _toConsumableArray(i)) : i,
      D = t(C),
      W = t(null),
      P = t(null),
      R = t(!1),
      L = t(!1),
      j = t(!1),
      z = t(0);

  var _u4 = u(function () {
    return {
      y: 0,
      x: 0,
      config: a
    };
  }),
      _u5 = _slicedToArray(_u4, 2),
      $ = _u5[0],
      q = _u5[1],
      k = r(function () {
    if (!P.current) return 0;
    var e = P.current ? P.current.querySelector(".use-spring-carousel-item") : null;
    if (!e) throw Error("No carousel items available!");
    return "x" === w ? e.getBoundingClientRect().width : e.getBoundingClientRect().height;
  }, [w]),
      H = r(function (e) {
    if ("number" == typeof S) {
      var _o2 = "x" === w ? "left" : "top";

      function _t2() {
        return k() * i.length;
      }

      function _n(t) {
        e.style.top = "0px", e.style.left = "0px", e.style[_o2] = "-".concat(t, "px");
      }

      function _r2() {
        _n(_t2());
      }

      if (S > 1) switch (A) {
        default:
        case "start":
          _r2();

          break;

        case "center":
          _n(_t2() - k() * Math.round((S - 1) / 2));

          break;

        case "end":
          _n(_t2() - k() * Math.round(S - 1));

      } else _r2();
    }
  }, [w, k, A, i.length, S]),
      M = r(function () {
    window.innerWidth !== z.current && (z.current = window.innerWidth, q.start({
      immediate: !0,
      x: 0,
      y: 0
    }), q.start(_defineProperty({
      immediate: !0
    }, w, -k() * ee())), o && H(P.current));
  }, [H, w, k, q, o]),
      _f = f(),
      Y = _f.useListenToCustomEvent,
      B = _f.emitObservable,
      _g = g({
    mainCarouselWrapperRef: W,
    emitObservable: B,
    handleResize: M
  }),
      G = _g.enterFullscreen,
      X = _g.exitFullscreen,
      J = _g.getIsFullscreen,
      _b = b({
    withThumbs: h,
    items: i,
    thumbsSlideAxis: y,
    springConfig: a,
    thumbsWrapperRef: T,
    prepareThumbsData: I
  }),
      K = _b.thumbsFragment,
      Q = _b.handleThumbsScroll,
      U = d(function (e) {
    var t = e.dragging,
        n = e.movement["x" === w ? 0 : 1],
        r = -k() * ee();

    function i() {
      q.start(_defineProperty({}, w, r));
    }

    if (t) {
      q.start(_defineProperty({}, w, r + n)), ne(!0), B(_objectSpread({
        eventName: "onDrag"
      }, e));

      var _t3 = n > s;

      n < -s ? (!o && ce() ? i() : de(), e.cancel()) : _t3 && (!o && le() ? i() : ae(), e.cancel());
    }

    e.last && i();
  }, {
    enabled: !F
  });

  function V(e) {
    E.current = e;
  }

  function Z() {
    return E.current;
  }

  function _(e) {
    D.current = e;
  }

  function ee() {
    return D.current;
  }

  function te(e) {
    L.current = e;
  }

  function ne(e) {
    R.current = e;
  }

  function re() {
    var e = ee();
    return 0 === e ? i.length - 1 : e - 1;
  }

  function ie() {
    var e = ee();
    return e === i.length - 1 ? 0 : e + 1;
  }

  function oe(e) {
    return i.findIndex(function (t) {
      return t.id === e;
    });
  }

  function se(_ref10) {
    var e = _ref10.from,
        t = _ref10.to,
        _ref10$immediate = _ref10.immediate,
        n = _ref10$immediate === void 0 ? !1 : _ref10$immediate,
        _ref10$onRest = _ref10.onRest,
        r = _ref10$onRest === void 0 ? function () {} : _ref10$onRest;
    n || (_(t), te(!0), B({
      eventName: "onSlideStartChange",
      nextItem: t,
      slideActionType: Z()
    })), q.start(_objectSpread(_objectSpread({}, e ? {
      from: _defineProperty({}, w, e)
    } : {}), {}, {
      to: _defineProperty({}, w, -k() * t),
      immediate: n,
      onRest: function onRest(e) {
        e.finished && (ne(!1), te(!1), r(), n || B({
          eventName: "onSlideChange",
          currentItem: ee(),
          slideActionType: Z()
        }));
      }
    })), x && h && !n && Q(t);
  }

  function ue(e) {
    if ("none" === e.style.transform) return 0;
    var t = e.style.transform.split(/\w+\(|\);?/);
    return Number(t[1].split(/,\s?/g)["x" === w ? 0 : 1].replace("px", ""));
  }

  function le() {
    return 0 === ee();
  }

  function ce() {
    return ee() === i.length - 1;
  }

  function ae() {
    !o && 0 === ee() || j.current || (V("prev"), le() ? se({
      from: -(Math.abs(ue(P.current)) + k() * i.length),
      to: i.length - 1
    }) : se({
      to: re()
    }));
  }

  function de() {
    !o && ee() === O.length - 1 || j.current || N.current || (V("next"), ce() ? se({
      from: ue(P.current) + k() * i.length,
      to: 0
    }) : se({
      to: ie()
    }));
  }

  p(function () {
    if (!Number.isInteger(S)) throw new Error("itemsPerSlide should be an integer.");
    if (S > i.length) throw new Error("The itemsPerSlide prop can't be greater than the total length of the items you provide.");
    if (S < 1) throw new Error("The itemsPerSlide prop can't be less than 1.");
    m || console.warn("You set shouldResizeOnWindowResize={false}; be aware that the carousel could behave in a strange way if you also use the fullscreen functionality or if you change the mobile orientation."), C < 0 && console.warn("The initialActiveItem cannot be less than 0."), C > i.length && console.warn("The initialActiveItem cannot be greater than the total length of the items you provide.");
  }), p(function () {
    function e() {
      document.hidden ? j.current = !0 : j.current = !1;
    }

    if (z.current = window.innerWidth, "undefined" != typeof window) return document.addEventListener("visibilitychange", e), function () {
      document.removeEventListener("visibilitychange", e);
    };
  }), n(function () {
    if (m) return window.addEventListener("resize", M), function () {
      window.removeEventListener("resize", M);
    };
  }, [M, m]), n(function () {
    P.current && ("x" === w && (P.current.style.top = "0px"), "y" === w && (P.current.style.left = "0px"));
  }, [w]), p(function () {
    C > 0 && C <= i.length && (se({
      to: C,
      immediate: !0
    }), _(C));
  }), n(function () {
    if (P.current) {
      var _e = P.current.querySelectorAll(".use-spring-carousel-item"),
          _t4 = _e[_e.length - 1],
          _n2 = new IntersectionObserver(function (e) {
        e[0].isIntersecting ? N.current = !0 : N.current = !1;
      }, {
        threshold: 1
      });

      return _n2.observe(_t4), function () {
        _n2.unobserve(_t4);
      };
    }
  }, [S]);
  var me = {
    useListenToCustomEvent: Y,
    getIsFullscreen: J,
    enterFullscreen: G,
    exitFullscreen: X,
    getIsAnimating: function getIsAnimating() {
      return L.current;
    },
    getIsDragging: function getIsDragging() {
      return R.current;
    },
    getIsNextItem: function getIsNextItem(e) {
      var t = oe(e),
          n = ee();
      return o && n === i.length - 1 ? 0 === t : t === n + 1;
    },
    getIsPrevItem: function getIsPrevItem(e) {
      var t = oe(e),
          n = ee();
      return o && 0 === n ? t === i.length - 1 : t === n - 1;
    },
    slideToPrevItem: ae,
    slideToNextItem: de,
    slideToItem: function slideToItem(e) {
      var t = 0;
      if (t = "string" == typeof e ? i.findIndex(function (t) {
        return t.id === e;
      }) : e, t >= i.length) throw Error("The item you want to slide to doesn't exist. This could be due to the fact that \n        you provide a wrong id or a higher numeric index.");
      if (t === ee()) return;
      var n = oe(i[ee()].id);
      V(oe(i[t].id) > n ? "next" : "prev"), se({
        to: t
      });
    },
    getIsActiveItem: function getIsActiveItem(e) {
      return oe(e) === ee();
    },
    getCurrentActiveItem: function getCurrentActiveItem() {
      return {
        id: i[ee()].id,
        index: ee()
      };
    }
  };
  return _objectSpread({
    carouselFragment: e(v.Provider, Object.assign({
      value: me
    }, {
      children: e("div", Object.assign({
        ref: W,
        "data-testid": "use-spring-carousel-wrapper",
        style: {
          display: "flex",
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden"
        }
      }, {
        children: e(l.div, Object.assign({}, U(), {
          "data-testid": "use-spring-carousel-animated-wrapper",
          style: _objectSpread(_objectSpread({
            display: "flex",
            flexDirection: "x" === w ? "row" : "column",
            top: 0,
            left: 0,
            position: "relative",
            width: "100%"
          }, $), {}, {
            touchAction: "none"
          }),
          ref: function ref(e) {
            e && (P.current = e, o && H(e));
          }
        }, {
          children: O.map(function (_ref11, r) {
            var t = _ref11.id,
                n = _ref11.renderItem;
            return e("div", Object.assign({
              className: "use-spring-carousel-item",
              "data-testid": "use-spring-carousel-item-wrapper",
              style: {
                display: "flex",
                position: "relative",
                flex: "1 0 calc(100% / ".concat(S, ")")
              }
            }, {
              children: n
            }), "".concat(t, "-").concat(r));
          })
        }), void 0)
      }), void 0)
    }), void 0),
    thumbsFragment: e(v.Provider, Object.assign({
      value: me
    }, {
      children: K
    }), void 0)
  }, me);
}

var y = i(void 0);

function T() {
  var e = o(y);
  if (!e) throw new Error("useTransitionCarouselContext isn't being used within the useTransitionCarousel context; \n    use the context only inside a component that is rendered within the Carousel.");
  return e;
}

function I(_ref12) {
  var n = _ref12.items,
      _ref12$withLoop = _ref12.withLoop,
      r = _ref12$withLoop === void 0 ? !1 : _ref12$withLoop,
      _ref12$withThumbs = _ref12.withThumbs,
      i = _ref12$withThumbs === void 0 ? !1 : _ref12$withThumbs,
      _ref12$springConfig = _ref12.springConfig,
      o = _ref12$springConfig === void 0 ? c.default : _ref12$springConfig,
      _ref12$thumbsSlideAxi = _ref12.thumbsSlideAxis,
      u = _ref12$thumbsSlideAxi === void 0 ? "x" : _ref12$thumbsSlideAxi,
      _ref12$enableThumbsWr = _ref12.enableThumbsWrapperScroll,
      m = _ref12$enableThumbsWr === void 0 ? !0 : _ref12$enableThumbsWr,
      _ref12$draggingSlideT = _ref12.draggingSlideTreshold,
      h = _ref12$draggingSlideT === void 0 ? 50 : _ref12$draggingSlideT,
      p = _ref12.prepareThumbsData,
      v = _ref12.toPrevItemSpringProps,
      x = _ref12.toNextItemSpringProps,
      _ref12$disableGesture = _ref12.disableGestures,
      w = _ref12$disableGesture === void 0 ? !1 : _ref12$disableGesture,
      _ref12$springAnimatio = _ref12.springAnimationProps,
      T = _ref12$springAnimatio === void 0 ? {
    initial: {
      opacity: 1,
      position: "relative"
    },
    from: {
      opacity: 0,
      position: "absolute"
    },
    enter: {
      opacity: 1,
      position: "relative"
    },
    leave: {
      opacity: 0,
      position: "absolute"
    }
  } : _ref12$springAnimatio;

  var I = t("next"),
      S = t(null),
      C = t(!1),
      _s2 = s(0),
      _s3 = _slicedToArray(_s2, 2),
      A = _s3[0],
      F = _s3[1],
      _f2 = f(),
      N = _f2.emitObservable,
      E = _f2.useListenToCustomEvent,
      _g2 = g({
    emitObservable: N,
    mainCarouselWrapperRef: S
  }),
      O = _g2.enterFullscreen,
      D = _g2.exitFullscreen,
      W = _g2.getIsFullscreen,
      _b2 = b({
    items: n,
    withThumbs: i,
    thumbsSlideAxis: u,
    springConfig: o,
    prepareThumbsData: p
  }),
      P = _b2.thumbsFragment,
      R = _b2.handleThumbsScroll,
      L = d(function (_ref13) {
    var e = _ref13.last,
        _ref13$movement = _slicedToArray(_ref13.movement, 1),
        t = _ref13$movement[0];

    if (!z() && e) {
      var _e2 = t > h,
          _i = t < -h,
          _o3 = 0 === A,
          _s4 = A === n.length - 1;

      if (_i) {
        if (!r && _s4) return;
        H(), N({
          eventName: "onLeftSwipe"
        });
      } else if (_e2) {
        if (!r && _o3) return;
        M(), N({
          eventName: "onRightSwipe"
        });
      }
    }
  }, {
    enabled: !w
  });

  var j = a(A, _objectSpread(_objectSpread({
    config: o
  }, function () {
    var e = k();
    return "prev" === e && v ? {
      initial: _objectSpread({}, T.initial),
      from: _objectSpread({}, v.from),
      enter: _objectSpread({}, v.enter),
      leave: _objectSpread({}, v.leave)
    } : "next" === e && x ? {
      initial: _objectSpread({}, T.initial),
      from: _objectSpread({}, x.from),
      enter: _objectSpread({}, x.enter),
      leave: _objectSpread({}, x.leave)
    } : {
      initial: _objectSpread({}, T.initial),
      from: _objectSpread({}, T.from),
      enter: _objectSpread({}, T.enter),
      leave: _objectSpread({}, T.leave)
    };
  }()), {}, {
    onStart: function onStart() {
      return $(!0);
    },
    keys: null,
    onRest: function onRest(e) {
      e.finished && ($(!1), N({
        eventName: "onSlideChange",
        currentItem: A,
        slideActionType: k()
      }));
    }
  }))(function (t, r) {
    return e(l.div, Object.assign({
      style: _objectSpread(_objectSpread({}, t), {}, {
        flex: "1 0 100%",
        width: "100%",
        height: "100%"
      })
    }, {
      children: n[r].renderItem
    }), void 0);
  });

  function z() {
    return C.current;
  }

  function $(e) {
    C.current = e;
  }

  function q(e) {
    I.current = e;
  }

  function k() {
    return I.current;
  }

  function H() {
    var e = A === n.length - 1;
    r ? (q("next"), e ? (N({
      eventName: "onSlideStartChange",
      nextItem: 0,
      slideActionType: k()
    }), F(0)) : (N({
      eventName: "onSlideStartChange",
      nextItem: A + 1,
      slideActionType: k()
    }), F(A + 1))) : e || (N({
      eventName: "onSlideStartChange",
      nextItem: A + 1,
      slideActionType: k()
    }), q("next"), F(A + 1));
  }

  function M() {
    var e = 0 === A;
    r ? (q("prev"), e ? (N({
      eventName: "onSlideStartChange",
      nextItem: n.length - 1,
      slideActionType: k()
    }), F(n.length - 1)) : (N({
      eventName: "onSlideStartChange",
      nextItem: A - 1,
      slideActionType: k()
    }), F(A - 1))) : e || (q("prev"), N({
      eventName: "onSlideStartChange",
      nextItem: A - 1,
      slideActionType: k()
    }), F(A - 1));
  }

  function Y(e) {
    return n.findIndex(function (t) {
      return t.id === e;
    });
  }

  var B = {
    activeItem: A,
    slideToItem: function slideToItem(e) {
      var t = 0;
      if (t = "string" == typeof e ? n.findIndex(function (t) {
        return t.id === e;
      }) : e, t >= n.length) throw Error("The item you want to slide to doesn't exist. This could be due to the fact that \n        you provide a wrong id or a higher numeric index.");
      if (t === A) return;
      var r = Y(n[A].id),
          o = Y(n[t].id);
      N({
        eventName: "onSlideStartChange",
        nextItem: o,
        slideActionType: k()
      }), q(o > r ? "next" : "prev"), F(t), m && i && R(t);
    },
    slideToNextItem: H,
    slideToPrevItem: M,
    enterFullscreen: O,
    exitFullscreen: D,
    useListenToCustomEvent: E,
    getIsNextItem: function getIsNextItem(e) {
      var t = Y(e);
      return r && A === n.length - 1 ? 0 === t : t === A + 1;
    },
    getIsPrevItem: function getIsPrevItem(e) {
      var t = Y(e);
      return r && 0 === A ? t === n.length - 1 : t === A - 1;
    },
    getIsAnimating: z,
    getIsFullscreen: W,
    getIsActiveItem: function getIsActiveItem(e) {
      return Y(e) === A;
    },
    getCurrentActiveItem: function getCurrentActiveItem() {
      return {
        id: n[A].id,
        index: A
      };
    }
  };
  return _objectSpread({
    carouselFragment: e(y.Provider, Object.assign({
      value: B
    }, {
      children: e("div", Object.assign({
        ref: S
      }, L(), {
        style: {
          display: "flex",
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden"
        }
      }, {
        children: j
      }), void 0)
    }), void 0),
    thumbsFragment: e(y.Provider, Object.assign({
      value: B
    }, {
      children: P
    }), void 0)
  }, B);
}

export { w as useSpringCarousel, x as useSpringCarouselContext, I as useTransitionCarousel, T as useTransitionCarouselContext };